import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ParticipantTypeEnum } from 'src/app/enum/participant.enum';
import { Signatory } from 'src/app/envelope/model/signatory';
import { Authorizer } from 'src/app/model/authorizer';
import { Observer } from 'src/app/model/observer';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { StringUtil } from 'src/app/util/string-util';

@Component({
  selector: 'app-contact-table',
  templateUrl: './contact-table.component.html',
  styleUrls: ['./contact-table.component.scss']
})
export class ContactTableComponent implements OnInit, OnChanges {

  @Input() participantType: ParticipantTypeEnum;
  @Input() showSSN: boolean = true;
  @Input() showTelephone: boolean = true;
  @Input() showSignatureType: boolean = true;
  @Input() showSubscriberType: boolean = true;
  @Input() elements: Array<Signatory> | Array<Authorizer> | Array<Observer>;
  @Input() searchValue: string;
  @Input() enableEditContact: boolean;
  @Output() addButtonClick = new EventEmitter();
  @Output() removeButtonClick: EventEmitter<(number | string)[]> = new EventEmitter();
  @Output() editButtonClick: EventEmitter<number | string> = new EventEmitter();
  @Output() searchValueChanged: EventEmitter<string> = new EventEmitter();
  @Output() onTableScroll = new EventEmitter();
  @Output() onTableChange = new EventEmitter();

  isSelectable: boolean = true;
  isSingleSelect: boolean = false;
  allSelected: boolean = false;
  partiallySelected: boolean = false;
  selectedCountElements: number = 0;
  inactiveTag = {
      description: 'inactive',
      tooltip: 'envelope.signatory.tooltip.signatoryTypeRoleInactive',
      tooltipPlacement: 'top'
    };

  ngOnInit() {
    if (this.participantType === ParticipantTypeEnum.Responsible) {
      this.isSelectable = false;
      this.isSingleSelect = true;
    }

    this.updateCounts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['elements'] && this.elements) {
      this.updateCounts();
    }
  }

  addClick() {
    this.addButtonClick.emit();
  }

  removeClick() {
    const ids = (this.elements as any[]).filter(el => el.checked).map(el => el.id);
    this.removeButtonClick.emit(ids);
  }

  editClick() {
    const item = (this.elements as any[]).find(el => el.checked);
    if (item?.id != null) {
      this.editButtonClick.emit(item.id);
    }
  }

  onSearch(value: string) {
    this.searchValueChanged.emit(value);
  }

  onSelectAll() {
    const checked = !this.allSelected;
    this.elements.forEach(el => (el as any).checked = checked);
    this.updateCounts();
    this.emitChange();
  }

  onRowClick(el: any) {
    if (this.isSingleSelect) {
      this.elements.forEach(e => (e as any).checked = false);
      el.checked = true;
    } else {
      el.checked = !el.checked;
    }
    this.updateCounts();
    this.emitChange();
  }

  onRowSelect(el: any, event: Event) {
    el.checked = (event.target as HTMLInputElement).checked;
    this.updateCounts();
    this.emitChange();
  }

  onScroll() {
    this.onTableScroll.emit();
  }

  showInactiveTag(el: any): boolean {
    return !!(el as Signatory).signatoryTypeRole && (el as Signatory).signatoryTypeRole?.isActive === false;
  }

  obfuscateMail(mail: string): string {
    return StringUtil.obfuscateMail(mail);
  }

  obfuscateSsn(ssn: string): string {
    return CPFCNPJUtil.obfuscateCpfCnpj(CPFCNPJUtil.formatSsn(ssn));
  }

  obfuscateTelephone(phone: string): string {
    return StringUtil.obfuscateTelephone(phone);
  }

  private updateCounts() {
    if (!this.elements) { return; }
    this.selectedCountElements = (this.elements as any[]).filter(el => el.checked).length;
    this.allSelected = this.selectedCountElements === this.elements.length && this.elements.length > 0;
    this.partiallySelected = this.selectedCountElements > 0 && !this.allSelected;
  }

  private emitChange() {
    const ids = (this.elements as any[]).filter(el => el.checked).map((el: any) => el.id);
    this.onTableChange.emit(ids);
  }
}

